import React, { useState, useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { ErrorMessage, Field } from 'formik'

// Local Imports
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import AdxAvatarSide from '../../adminLeaveSetting/components/AdxAvatarSide'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import Loading from 'components/dumb/loading/Loading'

// API services
import { useGetApprovalRoute } from 'services/api/modules/leave/leavePolicy/approvalGroup'

const PolicyApproval = ({ formikBag }) => {
  const { values, handleChange, errors, touched } = formikBag
  const { data: options = [], isLoading } = useGetApprovalRoute()
  const [selectedApprovalRoute, setSelectedApprovalRoute] = useState()
  const [selectedRoutes, setSelectedRoutes] = useState([])

  const getRouteLayers = (route) => {
    if (!route) return []

    const layers = [
      route.layer_one,
      route.layer_two,
      route.layer_three,
      route.layer_four,
      route.layer_five,
    ]

    return layers.slice(0, Number(route.num_layers) || 0).filter(Boolean)
  }

  const formatMembers = (members = []) => {
    if (!members.length) return 'No members configured'

    return members.map((employee, index, arr) => {
      return index === arr.length - 1
        ? `${employee.name}.`
        : index === arr.length - 2
        ? `${employee.name} & `
        : `${employee.name}, `
    })
  }

  useEffect(() => {
    const selected = options?.find((option) => option.id === values.approval_route_id)
    setSelectedApprovalRoute(selected)
    setSelectedRoutes(getRouteLayers(selected))
  }, [values.approval_route_id, options])

  if (isLoading) {
    return <Loading show={isLoading} />
  }

  return (
    <Box display="flex" flexDirection="column" rowGap={4}>
      <Field
        as={AdxDropdown}
        name="approval_route_id"
        value={values.approval_route_id}
        onChange={(event) => {
          handleChange(event)
        }}
        label="Approval route"
        sx={{ width: { xs: 1, lg: 0.6 } }}
        errorMessage={<ErrorMessage name="approval_route_id" component={AdxErrorMessage} />}
        isErrorShown={errors.approval_route_id && touched.approval_route_id}
      >
        {options.map((option) => (
          <AdxMenuItem key={option.id} value={option.id} selectedvalue={values.approval_route_id}>
            {option.name}
          </AdxMenuItem>
        ))}
      </Field>

      {values.approval_route_id && (
        <>
          <Box display="flex" alignItems="center" columnGap={2}>
            <Typography>Route</Typography>
            <Typography color="light-gray-text.main">
              {selectedApprovalRoute?.num_layers === 1
                ? `${selectedApprovalRoute?.num_layers} layer`
                : `${selectedApprovalRoute?.num_layers} layers`}
            </Typography>
          </Box>
          <Box p={1} border="1px solid" borderColor="gray-line.main" borderRadius={'10px'}>
            {selectedRoutes?.map((list, index, arr) => {
              return (
                <Box
                  key={index}
                  borderBottom={index === arr.length - 1 ? 'none' : 1}
                  borderColor="gray-line.main"
                  height="auto"
                  paddingX={3}
                  paddingY={2}
                  maxHeight={{ xs: 'initial', lg: 100 }}
                >
                  <Box
                    display="flex"
                    alignItems={{ xs: 'flex-start', lg: 'center' }}
                    flexDirection={{ xs: 'column', lg: 'row' }}
                  >
                    <Box minWidth={{ xs: 55, lg: 80 }}>
                      <Typography noWrap variant="body1" color="light-gray-text.main">
                        Layer {index + 1}
                      </Typography>
                    </Box>
                    <Box
                      width={{ xs: '100%', lg: 'calc(100% - 20px)' }}
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      my={{ xs: 2, lg: 0 }}
                    >
                      <Box display="flex" alignItems="center">
                        <Box
                          width={70}
                          height={60}
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          marginRight={1}
                        >
                          <AdxAvatarSide active data={list.members || []} />
                        </Box>
                        <Box maxWidth={700} width={{ xs: '100%' }}>
                          <Typography>{list.name}</Typography>
                          <Typography
                            mt={0.5}
                            variant="body2"
                            color="light-gray-text.main"
                            separator=","
                            sx={{ fontSize: 14 }}
                          >
                            {formatMembers(list.members)}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )
            })}
          </Box>
        </>
      )}
    </Box>
  )
}

export default PolicyApproval
